import {toDate} from './date_helper'

// 1543622400000 is a timestamp of 12. December 0:0:0
export const idNumber = (id,timestamp) =>
  `${id.substring(0,2).toUpperCase()}-${timestamp-1543622400000}`

export const billNumber = (order) => {
  const date = toDate(order.date)
  const count = order.count
  return `${date.getFullYear()}${date.getMonth()+1}${date.getDate()}-${count}`
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/share/id_helper.js